/**
 * Labstep
 */

import { SignatureListEntityStateContainer as SignatureListEntityState } from 'labstep-web/components/Signature/List/EntityState';
import type { EntityState } from 'labstep-web/models/entity-state.model';
import type React from 'react';
import type { ExperimentWorkflowActionUpdateEntityStateModalWizardStepAssignProps } from './types';

export const ExperimentWorkflowActionUpdateEntityStateModalWizardStepAssign: React.FC<
  ExperimentWorkflowActionUpdateEntityStateModalWizardStepAssignProps
> = ({ experimentWorkflow, nextEntityState }) => {
  return (
    <SignatureListEntityState
      entityState={nextEntityState as EntityState}
      experimentWorkflow={experimentWorkflow}
      round={experimentWorkflow.entity_state_round}
      showState={false}
    />
  );
};
